(function () {
  const SELECTORS = {
    abQuantityOption: '.ab-buybox__quantity-option',
    abFlavorOption: '.ab-buybox__flavor',
    abOfferCard: '.ab-buybox__offer-card',

    abSubscriptionPrice: '[data-ab-subscription-price]',
    abSubscriptionCompare: '[data-ab-subscription-compare]',
    abOneTimeCompare: '[data-ab-onetime-compare]',
    abOneTimePrice: '[data-ab-onetime-price]',

    kachingBundle: 'kaching-bundle',

    // Only quantity deal bars. This excludes the subscription checkbox bar.
    kachingBar:
      'kaching-bundle .kaching-bundles__bars:not(.kaching-bundles__subscriptions) > .kaching-bundles__bar',
    kachingSelectedBar:
      'kaching-bundle .kaching-bundles__bars:not(.kaching-bundles__subscriptions) > .kaching-bundles__bar--selected',

    kachingSubscriptionBar:
      'kaching-bundle .kaching-bundles__subscriptions .kaching-bundles__bar[role="checkbox"]',

    kachingPrice: '.kaching-bundles__bar-price',
    kachingComparePrice: '.kaching-bundles__bar-full-price',
    kachingVariantSelect: 'select.kaching-bundles__bar-variant-select',

    stickyButton: '.kaching-bundles-sticky-atc__button',
    buyBox: '.ab-pdp-buybox-v2',
    quantitySection: '.ab-buybox__quantity'
  };

  let cachedSellingPlanId = null;
  let selectedOfferState = 'subscription';
  let isMeasuringPrices = false;
  let priceSyncToken = 0;

  function wait(milliseconds) {
    return new Promise((resolve) => {
      window.setTimeout(resolve, milliseconds);
    });
  }

  function getTextWithoutChildren(element) {
    if (!element) return '';

    return Array.from(element.childNodes)
      .filter((node) => node.nodeType === Node.TEXT_NODE)
      .map((node) => node.textContent.trim())
      .join(' ')
      .trim();
  }

  function getSelectedKachingBar() {
    return document.querySelector(SELECTORS.kachingSelectedBar);
  }

  function getKachingBars() {
    return Array.from(document.querySelectorAll(SELECTORS.kachingBar));
  }

  function getKachingSubscriptionBar() {
    return document.querySelector(SELECTORS.kachingSubscriptionBar);
  }

  function getProductForm() {
    return document.querySelector('product-form form[action="/cart/add"]');
  }

  function getSellingPlanInput() {
    const form = getProductForm();

    if (!form) return null;

    return form.querySelector('input[name="selling_plan"]');
  }

  function cacheSellingPlanId() {
    const sellingPlanInput = getSellingPlanInput();
    const kachingBlock = document.querySelector('kaching-bundles-block');

    if (sellingPlanInput?.value) {
      cachedSellingPlanId = sellingPlanInput.value;
      return;
    }

    if (kachingBlock?.dataset?.sellingPlanId) {
      cachedSellingPlanId = kachingBlock.dataset.sellingPlanId;
    }
  }

  function forceFormSubscriptionState(shouldSubscribe) {
    const form = getProductForm();

    if (!form) return;

    cacheSellingPlanId();

    let sellingPlanInput = getSellingPlanInput();

    if (shouldSubscribe) {
      if (!sellingPlanInput) {
        sellingPlanInput = document.createElement('input');
        sellingPlanInput.type = 'hidden';
        sellingPlanInput.name = 'selling_plan';
        form.prepend(sellingPlanInput);
      }

      if (cachedSellingPlanId) {
        sellingPlanInput.value = cachedSellingPlanId;
        sellingPlanInput.disabled = false;
      }

      return;
    }

    if (sellingPlanInput) {
      sellingPlanInput.disabled = true;
      sellingPlanInput.removeAttribute('name');
    }
  }

  function triggerRealClick(element) {
    if (!element) return;

    element.dispatchEvent(
      new MouseEvent('mousedown', {
        bubbles: true,
        cancelable: true,
        view: window
      })
    );

    element.dispatchEvent(
      new MouseEvent('mouseup', {
        bubbles: true,
        cancelable: true,
        view: window
      })
    );

    element.dispatchEvent(
      new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      })
    );
  }

  function getKachingBlockData() {
    const block = document.querySelector('kaching-bundles-block');

    if (!block) return null;

    try {
      return {
        dealBlock: JSON.parse(block.getAttribute('deal-block') || '{}'),
        product: JSON.parse(block.getAttribute('product') || '{}')
      };
    } catch (error) {
      console.warn('[AB PDP] Could not parse Kaching data', error);
      return null;
    }
  }

  function getSelectedKachingDealBarConfig() {
    const selectedBar = getSelectedKachingBar();
    const data = getKachingBlockData();

    if (!selectedBar || !data?.dealBlock?.dealBars) return null;

    const selectedDealBarId = selectedBar.getAttribute('data-deal-bar-id');

    return data.dealBlock.dealBars.find((dealBar) => dealBar.id === selectedDealBarId);
  }

  function readSelectedKachingPrice() {
    const selectedBar = getSelectedKachingBar();
    const priceElement = selectedBar?.querySelector(SELECTORS.kachingPrice);

    return getTextWithoutChildren(priceElement);
  }

  function readSelectedKachingComparePrice() {
    const selectedBar = getSelectedKachingBar();
    const compareElement = selectedBar?.querySelector(SELECTORS.kachingComparePrice);

    return compareElement?.textContent.trim() || '';
  }

  function isKachingSubscriptionActive() {
    const subscriptionBar = getKachingSubscriptionBar();

    if (!subscriptionBar) return false;

    return subscriptionBar.getAttribute('aria-checked') === 'true';
  }

  function setKachingSubscriptionState(shouldSubscribe) {
    const subscriptionBar = getKachingSubscriptionBar();

    if (!subscriptionBar) return false;

    const isCurrentlySubscribed = isKachingSubscriptionActive();

    if (isCurrentlySubscribed === shouldSubscribe) {
      forceFormSubscriptionState(shouldSubscribe);
      return true;
    }

    const clickable =
      subscriptionBar.querySelector('.kaching-bundles__bar-main') ||
      subscriptionBar.querySelector('.kaching-bundles__subscriptions__card') ||
      subscriptionBar;

    triggerRealClick(clickable);
    forceFormSubscriptionState(shouldSubscribe);

    return true;
  }

  async function measureKachingPriceForOffer(offerType) {
    const shouldSubscribe = offerType === 'subscription';

    setKachingSubscriptionState(shouldSubscribe);

    // Give Kaching time to update the active price.
    await wait(260);

    return {
      price: readSelectedKachingPrice(),
      comparePrice: readSelectedKachingComparePrice()
    };
  }

  function syncOfferSubtitles(selectedDealBar) {
    const subscriptionSubtitle = document.querySelector(
      '.ab-buybox__offer-card--subscription .ab-buybox__offer-subtitle'
    );

    const oneTimeSubtitle = document.querySelector(
      '.ab-buybox__offer-card--onetime .ab-buybox__offer-subtitle'
    );

    const servingsLabel = selectedDealBar?.subtitle || '';

    if (subscriptionSubtitle && servingsLabel) {
      subscriptionSubtitle.textContent = `Delivered every 30 days - ${servingsLabel}`;
    }

    if (oneTimeSubtitle && servingsLabel) {
      oneTimeSubtitle.textContent = `${servingsLabel} - delivered once`;
    }
  }

  async function syncAbBuyboxPrices() {
    if (isMeasuringPrices) return;

    const selectedKachingBar = getSelectedKachingBar();
    const selectedDealBar = getSelectedKachingDealBarConfig();

    if (!selectedKachingBar) return;

    const currentToken = ++priceSyncToken;
    const originalOfferState = selectedOfferState;

    isMeasuringPrices = true;

    try {
      syncOfferSubtitles(selectedDealBar);

      const subscriptionData = await measureKachingPriceForOffer('subscription');

      if (currentToken !== priceSyncToken) return;

      const oneTimeData = await measureKachingPriceForOffer('onetime');

      if (currentToken !== priceSyncToken) return;

      // Restore the actual user-selected offer after measuring both prices.
      setKachingSubscriptionState(originalOfferState === 'subscription');

      await wait(120);

      if (currentToken !== priceSyncToken) return;

      const subscriptionPrice = document.querySelector(SELECTORS.abSubscriptionPrice);
      const oneTimePrice = document.querySelector(SELECTORS.abOneTimePrice);

      const subscriptionCompare = document.querySelector(SELECTORS.abSubscriptionCompare);
      const oneTimeCompare = document.querySelector(SELECTORS.abOneTimeCompare);

      if (subscriptionPrice && subscriptionData.price) {
        subscriptionPrice.textContent = subscriptionData.price;
      }

      if (oneTimePrice && oneTimeData.price) {
        oneTimePrice.textContent = oneTimeData.price;
      }

      if (subscriptionCompare) {
        subscriptionCompare.textContent =
          subscriptionData.comparePrice || oneTimeData.comparePrice || '';
      }

      if (oneTimeCompare) {
        oneTimeCompare.textContent =
          oneTimeData.comparePrice || subscriptionData.comparePrice || '';
      }

      updateOfferVisualState(originalOfferState);
      forceFormSubscriptionState(originalOfferState === 'subscription');
    } finally {
      isMeasuringPrices = false;
    }
  }

  function syncActiveQuantityFromKaching() {
    const kachingBars = getKachingBars();

    const selectedIndex = kachingBars.findIndex((bar) =>
      bar.classList.contains('kaching-bundles__bar--selected')
    );

    if (selectedIndex < 0) return;

    document.querySelectorAll(SELECTORS.abQuantityOption).forEach((button) => {
      const buttonIndex = Number(button.dataset.kachingDealIndex);
      const isActive = buttonIndex === selectedIndex;

      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function selectKachingDealByIndex(dealIndex) {
    const kachingBars = getKachingBars();
    const targetBar = kachingBars[dealIndex];

    if (!targetBar) return false;

    const clickable =
      targetBar.querySelector('.kaching-bundles__bar-main') ||
      targetBar.querySelector('.kaching-bundles__bar-container') ||
      targetBar.querySelector('label') ||
      targetBar;

    triggerRealClick(clickable);

    return true;
  }

  function updateQuantityVisualState(selectedButton) {
    document.querySelectorAll(SELECTORS.abQuantityOption).forEach((button) => {
      const isActive = button === selectedButton;

      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function updateFlavorVisualState(packIndex, selectedButton) {
    const packButtons = document.querySelectorAll(
      `${SELECTORS.abFlavorOption}[data-pack-index="${packIndex}"]`
    );

    packButtons.forEach((button) => {
      const isActive = button === selectedButton;

      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function updateOfferVisualState(selectedOffer) {
    document.querySelectorAll(SELECTORS.abOfferCard).forEach((card) => {
      const isActive = card.dataset.offer === selectedOffer;

      card.classList.toggle('is-active', isActive);
      card.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function setSelectValueSilently(select, value) {
    const nativeSelectSetter = Object.getOwnPropertyDescriptor(
      window.HTMLSelectElement.prototype,
      'value'
    )?.set;

    if (nativeSelectSetter) {
      nativeSelectSetter.call(select, value);
    } else {
      select.value = value;
    }

    select.setAttribute('data-value', value);
  }

  function triggerSelectEvents(select) {
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function getSelectedCustomFlavorValues() {
    const values = [];

    document.querySelectorAll('[data-ab-pack]').forEach((pack) => {
      if (pack.hidden) return;

      const packIndex = Number(pack.dataset.abPack);
      const activeFlavorButton = pack.querySelector(
        `${SELECTORS.abFlavorOption}.is-active`
      );

      if (!activeFlavorButton) return;

      const flavorValue = activeFlavorButton.dataset.flavor;

      if (!flavorValue) return;

      values[packIndex] = flavorValue;
    });

    return values;
  }

  function applyCustomFlavorsToKaching() {
    const selectedKachingBar = getSelectedKachingBar();

    if (!selectedKachingBar) return false;

    const flavorSelects = Array.from(
      selectedKachingBar.querySelectorAll(SELECTORS.kachingVariantSelect)
    );

    if (!flavorSelects.length) return false;

    const customValues = getSelectedCustomFlavorValues();

    // First pass: set all values silently.
    flavorSelects.forEach((select, index) => {
      const value = customValues[index];

      if (!value) return;

      setSelectValueSilently(select, value);
    });

    // Second pass: re-apply values and trigger Kaching events.
    window.setTimeout(() => {
      flavorSelects.forEach((select, index) => {
        const value = customValues[index];

        if (!value) return;

        setSelectValueSilently(select, value);
        triggerSelectEvents(select);
      });
    }, 50);

    return true;
  }

  function syncVisiblePacks() {
    const selectedKachingBar = getSelectedKachingBar();

    if (!selectedKachingBar) return;

    const flavorSelects = selectedKachingBar.querySelectorAll(
      SELECTORS.kachingVariantSelect
    );

    const visiblePackCount = flavorSelects.length || 1;

    document.querySelectorAll('[data-ab-pack]').forEach((pack) => {
      const packIndex = Number(pack.dataset.abPack);
      pack.hidden = packIndex >= visiblePackCount;
    });
  }

  function syncKachingFlavorsFromCustomState() {
    applyCustomFlavorsToKaching();
  }

  function syncOfferVisualStateFromKaching() {
    if (isMeasuringPrices) return;

    const isSubscribed = isKachingSubscriptionActive();

    selectedOfferState = isSubscribed ? 'subscription' : 'onetime';
    updateOfferVisualState(selectedOfferState);
  }

  function initQuantitySync() {
    const quantityButtons = document.querySelectorAll(SELECTORS.abQuantityOption);

    quantityButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const dealIndex = Number(button.dataset.kachingDealIndex);
        const didSelect = selectKachingDealByIndex(dealIndex);

        if (!didSelect) return;

        updateQuantityVisualState(button);

        // Let Kaching switch the active deal first.
        window.setTimeout(() => {
          syncAbBuyboxPrices();
          syncActiveQuantityFromKaching();
          syncVisiblePacks();
        }, 300);

        // Then apply the selected custom flavors after Kaching has rebuilt its selects.
        window.setTimeout(() => {
          syncKachingFlavorsFromCustomState();
          syncAbBuyboxPrices();
        }, 900);
      });
    });
  }

  function initFlavorSync() {
    const flavorButtons = document.querySelectorAll(SELECTORS.abFlavorOption);

    flavorButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const packIndex = Number(button.dataset.packIndex);

        updateFlavorVisualState(packIndex, button);
        applyCustomFlavorsToKaching();

        window.setTimeout(() => {
          syncAbBuyboxPrices();
        }, 300);
      });
    });
  }

  function initOfferSync() {
    const offerCards = document.querySelectorAll(SELECTORS.abOfferCard);

    offerCards.forEach((card) => {
      card.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const selectedOffer = card.dataset.offer;

        if (!selectedOffer) return;

        selectedOfferState = selectedOffer;

        updateOfferVisualState(selectedOffer);

        if (selectedOffer === 'subscription') {
          setKachingSubscriptionState(true);
          forceFormSubscriptionState(true);
        }

        if (selectedOffer === 'onetime') {
          setKachingSubscriptionState(false);
          forceFormSubscriptionState(false);
        }

        window.setTimeout(() => {
          forceFormSubscriptionState(selectedOfferState === 'subscription');
          syncAbBuyboxPrices();
          updateOfferVisualState(selectedOfferState);
        }, 300);

        window.setTimeout(() => {
          forceFormSubscriptionState(selectedOfferState === 'subscription');
          updateOfferVisualState(selectedOfferState);
        }, 900);
      });
    });
  }

  function syncInitialFlavorStateFromMarkupOnly() {
    document.querySelectorAll('[data-ab-pack]').forEach((pack) => {
      const packIndex = Number(pack.dataset.abPack);
      const activeButton = pack.querySelector(`${SELECTORS.abFlavorOption}.is-active`);

      if (!activeButton) return;

      updateFlavorVisualState(packIndex, activeButton);
    });
  }

  function syncAllFromKaching() {
    if (!isMeasuringPrices) {
      syncAbBuyboxPrices();
    }

    syncActiveQuantityFromKaching();
    syncVisiblePacks();

    /*
      Do not sync flavor visual state from Kaching on every mutation.
      Kaching may sync/re-render the same flavor across internal selects.
      The custom UI keeps flavor visual state independently per pack.
    */
  }

  function initShippingMessageUpdate() {
    const shippingMessage = document.querySelector('.product__tax.caption.rte');

    if (!shippingMessage || shippingMessage.dataset.bwoShippingUpdated === 'true') return;

    shippingMessage.innerHTML = shippingMessage.innerHTML.replace(
      'US orders',
      '<strong>US</strong> orders'
    );

    shippingMessage.dataset.bwoShippingUpdated = 'true';
  }

  function moveShopPayTerms() {
    const shopPayTerms = document.querySelector('shopify-payment-terms');
    const paymentIcons = document.querySelector('.product_payment__icon');

    if (!shopPayTerms || !paymentIcons) {
      return false;
    }

    if (shopPayTerms.dataset.bwoMoved === 'true') {
      return true;
    }

    paymentIcons.insertAdjacentElement('afterend', shopPayTerms);
    shopPayTerms.dataset.bwoMoved = 'true';

    return true;
  }

  function initShopPayTermsMove() {
    moveShopPayTerms();

    const interval = setInterval(() => {
      if (moveShopPayTerms()) {
        clearInterval(interval);
      }
    }, 250);

    setTimeout(() => {
      clearInterval(interval);
    }, 10000);
  }

  function initKachingStickyAtcScrollWithRetry(attempts = 20) {
    const stickyButton = document.querySelector(SELECTORS.stickyButton);

    if (!stickyButton) {
      if (attempts <= 0) return;

      window.setTimeout(() => {
        initKachingStickyAtcScrollWithRetry(attempts - 1);
      }, 250);

      return;
    }

    if (stickyButton.dataset.abScrollInitialized === 'true') return;

    stickyButton.dataset.abScrollInitialized = 'true';

    stickyButton.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const quantitySelector =
          document.querySelector(SELECTORS.quantitySection) ||
          document.querySelector(SELECTORS.buyBox);

        if (!quantitySelector) return;

        quantitySelector.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      },
      true
    );
  }

  function waitForKaching(callback, attempts = 30) {
    const kachingBundle = document.querySelector(SELECTORS.kachingBundle);

    if (kachingBundle && getKachingBars().length) {
      callback(kachingBundle);
      return;
    }

    if (attempts <= 0) return;

    window.setTimeout(() => {
      waitForKaching(callback, attempts - 1);
    }, 200);
  }

  function initAbPdpV2Test() {
    if (document.body.classList.contains('ab-pdp-v2-test-initialized')) return;

    document.body.classList.add('ab-pdp-v2-test-initialized');

    initShippingMessageUpdate();
    initShopPayTermsMove();

    initQuantitySync();
    initFlavorSync();
    initOfferSync();
    initKachingStickyAtcScrollWithRetry();

    syncInitialFlavorStateFromMarkupOnly();

    waitForKaching((kachingBundle) => {
      syncAllFromKaching();
      syncOfferVisualStateFromKaching();
      forceFormSubscriptionState(selectedOfferState === 'subscription');

      // Apply initial visual selections to Kaching.
      window.setTimeout(() => {
        syncVisiblePacks();
        syncKachingFlavorsFromCustomState();
        syncAbBuyboxPrices();
        updateOfferVisualState(selectedOfferState);
        forceFormSubscriptionState(selectedOfferState === 'subscription');
      }, 900);

      const observer = new MutationObserver(() => {
        syncAllFromKaching();

        if (!isMeasuringPrices) {
          updateOfferVisualState(selectedOfferState);
          forceFormSubscriptionState(selectedOfferState === 'subscription');
        }
      });

      observer.observe(kachingBundle, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: [
          'class',
          'data-value',
          'value',
          'checked',
          'aria-checked'
        ]
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAbPdpV2Test);
  } else {
    initAbPdpV2Test();
  }
})();